export default __webpack_public_path__ + "static/media/b.15866827.svg";